import { useEffect, useRef, useState } from 'react'

import * as S from './styles'
import { useScrollMouseWheel } from '@/hooks/useScrollMouseWheel'

export type SelectInputProps = {
  label: string
  name: string
  options: {
    id: string
    value: string
  }[]
  value: string
  onChange: (value: string) => void
  error?: string | null
  onBlur?: () => void
}
export const SelectInput: React.FC<SelectInputProps> = ({
  label,
  name,
  options,
  value,
  onChange,
  error,
  onBlur,
}) => {
  const [openOptions, setOpenOptions] = useState(false)
  const [hiddenError, setHiddenError] = useState(false)
  const { scrollContainer } = useScrollMouseWheel()
  const input = useRef<HTMLInputElement>(null)

  const handleOpenOptions = () => setOpenOptions((prev) => !prev)

  const handleClick = (event: MouseEvent) => {
    if (!(event.target as Element).matches('.select-input')) {
      setOpenOptions(false)
    }
  }

  const handleFocusIn = () => setHiddenError(true)
  const handleFocusOut = () => setHiddenError(false)

  useEffect(() => {
    const newInput = input.current
    if (newInput) {
      newInput.addEventListener('focusin', handleFocusIn)
      newInput.addEventListener('focusout', handleFocusOut)
    }

    return () => {
      if (newInput) {
        newInput.removeEventListener('focusin', handleFocusIn)
        newInput.removeEventListener('focusout', handleFocusOut)
      }
    }
  }, [])

  useEffect(() => {
    if (openOptions) {
      document.addEventListener('click', (e) => handleClick(e), {
        passive: true,
      })
    }
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [openOptions])
  return (
    <S.SelectContainer error={Boolean(error)}>
      <span>{label}</span>
      <input
        readOnly
        name={name}
        onClick={handleOpenOptions}
        className="select-input"
        placeholder="Selecione..."
        value={value}
        onBlur={onBlur}
        ref={input}
      />
      {error && !hiddenError && !openOptions && <S.Error>{error}</S.Error>}
      <div
        className={`options ${openOptions ? 'open' : ''}`}
        ref={scrollContainer}
      >
        {options.map((option) => (
          <button
            key={option.id}
            type="button"
            onClick={() => onChange(option.id)}
          >
            {option.value}
          </button>
        ))}
      </div>
    </S.SelectContainer>
  )
}
